<template>
  <div
    class="relative w-full overflow-hidden rounded-3xl"
    data-test-id="visa-help-offer-card"
    data-qa-id="visa.entry.specialOffer"
    @click="openVisaSection"
  >
    <div
      class="absolute inset-0 w-full bg-cover bg-no-repeat"
      :style="{ backgroundImage: `url(${visaPromoBg})` }"
    ></div>

    <div
      class="absolute inset-0"
      style="
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.6) 100%
        );
      "
    ></div>

    <div
      class="relative flex min-h-64 w-full flex-col justify-between gap-2 p-4"
      :class="{
        'items-center text-center': isCentered,
        'pb-10': isCentered && !isSingleOffer,
      }"
    >
      <div class="flex items-center gap-2 self-start">
        <div
          class="bg-static-white/10 flex items-center gap-1 rounded-full px-2 py-1"
          :style="{ backdropFilter: 'blur(50px)' }"
        >
          <p class="text-static-white text-xs font-medium">
            {{ t('visa-offer-card.tag') }}
          </p>
        </div>
      </div>

      <div class="flex flex-col gap-1" :class="{ 'items-center': isCentered }">
        <p class="text-static-white text-lg font-semibold">
          {{ t('visa-offer-card.title') }}
        </p>
        <p class="text-static-white/80 text-sm">
          {{ t('visa-offer-card.subtitle') }}
        </p>
        <button
          type="button"
          class="text-text-neutral-secondary bg-situational-lightgrey mt-2 w-fit rounded-2xl px-6 py-2 text-xs font-medium"
          data-qa-id="visa.entry.specialOffer.button"
          @click.stop="openVisaSection"
        >
          {{ t('visa-offer-card.cta') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  import visaPromoBg from '../../assets/visa-promo.webp';

  defineProps<{
    isCentered?: boolean;
    isSingleOffer?: boolean;
  }>();

  const { t } = useI18n();
  const router = useRouter();

  const openVisaSection = () => {
    router.push('/visa?source=special_offer');
  };
</script>
